export default {
    NO_ITEM_SELECTED: 'Du hast keinen Gegenstand zum Verzaubern ausgewählt.',
    CANNOT_ENCHANT: 'Der von dir ausgewählte Gegenstand kann nicht verzaubert werden.',
    NO_SHARD: 'Du musst einen Scherbe bereitstellen, um einen Gegenstand zu verzaubern.',
    FAILED_ENCHANT: 'Du hast versucht zu verzaubern, aber nichts ist passiert.',
    SUCCESSFUL_ENCHANT: 'Du hast deinen Gegenstand erfolgreich verzaubert.'
} as const;
